'use strict';

/** @type {import('./floor')} */
module.exports = Math.floor;



//////////////////
// WEBPACK FOOTER
// ../math-intrinsics/floor.js
// module id = 526
// module chunks = 0